import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { logError } from "@/lib/log";

export const SupporterStreak = ({ token, name }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    api.get(`/supporters/view/${token}/streak`, { params: { tz } }).then((r) => setData(r.data)).catch((e) => logError("Streak load failed:", e));
  }, [token]);

  const toggle = async (enabled) => {
    setData((d) => ({ ...d, reminders: enabled }));
    await api.post(`/supporters/view/${token}/streak-reminders`, { enabled }).catch((e) => {
      logError("Reminder toggle failed:", e);
      setData((d) => ({ ...d, reminders: !enabled }));
    });
  };

  if (!data) return null;
  const { streak } = data;
  return (
    <div className="mm-card p-5" data-testid="supporter-streak">
      <div className="flex items-center gap-4">
        <div className="text-3xl">{streak > 0 ? "🔥" : "🌱"}</div>
        <div>
          <div className="font-semibold text-lg" data-testid="supporter-streak-count">{streak > 0 ? `${streak}-week streak` : "Start a streak"}</div>
          <div className="text-sm text-mm-muted">
            {streak > 0 ? `You've encouraged ${name} ${streak} week${streak > 1 ? "s" : ""} in a row. Send a note this week to keep it going.` : `Send ${name} a note this week to start your encouragement streak.`}
          </div>
        </div>
      </div>
      <label className="flex items-center justify-between gap-3 mt-4 pt-4 border-t text-sm">
        <span className="text-mm-muted">Friday 5pm reminder if my streak is about to end</span>
        <Switch checked={data.reminders} onCheckedChange={toggle} data-testid="supporter-streak-reminders-toggle" />
      </label>
    </div>
  );
};
